import { render, staticRenderFns } from "./ScreenLayout.vue?vue&type=template&id=ca57980c"
import script from "./ScreenLayout.vue?vue&type=script&lang=js"
export * from "./ScreenLayout.vue?vue&type=script&lang=js"
import style0 from "./ScreenLayout.vue?vue&type=style&index=0&id=ca57980c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports